module.exports = __webpack_public_path__ + "img/00 banner.b3ac3d51.png";